import axios from "axios";

export const createTicket = async ({ ticket, name, email, phone, eventId, paymentMethod, voucherCode, seatNumber, seatZone, seats, quantity, customValue }) => {
  const response = await axios.post("subscriptions", {
    eventId,
    ticket, 
    name,
    email,
    phone,
    paymentMethod,
    voucherCode,
    seatNumber,
    seatZone,
    // An order may cover several seats, or several tickets of one type
    seats,
    quantity,
    customValue
  });

  return response;
};

export const createTicketAdmin = async (eventId, { ticket, name, email, phone, paidBy, willSendEmail, seatNumber, seatZone, seats, quantity, customValue }) => {
  const response = await axios.post(`/subscriptions/admin/${eventId}`, {
    eventId,
    ticket, 
    name,
    email,
    phone,
    paidBy,
    willSendEmail,
    seatNumber,
    seatZone,
    // An order may cover several seats, or several tickets of one type
    seats,
    quantity,
    customValue
  });

  return response;
};
export const validateTicket = (code) => axios.post(`/subscriptions/validate`, { code });

// How the buyer's own order ended: paid, still waiting, or cancelled and refunded
export const getOrderStatus = (viewToken) => axios.get(`/subscriptions/order/${viewToken}`);

// Payments that were taken but could not be honoured (admin only)
export const getRefunds = (eventId) => axios.get(`/subscriptions/admin/${eventId}/refunds`);
export const retryRefund = (eventId, ticketId) =>
  axios.post(`/subscriptions/admin/${eventId}/refunds/${ticketId}/retry`);
export const getTicketById = (eventId, ticketId) => axios.get(`/subscriptions/admin/${eventId}/${ticketId}`);
// The short link for a ticket, to send to the person it is for
export const getTicketShareLink = (eventId, ticketId) =>
  axios.get(`/subscriptions/admin/${eventId}/${ticketId}/share`);
export const updateTicket = (eventId, ticketId, data) => axios.put(`/subscriptions/admin/${eventId}/${ticketId}`, data);
export const deleteTicket = (eventId, ticketId) => axios.delete(`/subscriptions/admin/${eventId}/${ticketId}`);

export const updateSubscription = async (
  id,
  { plateNumber, type, captchaToken }
) => {
  const response = await axios.put(`vehicles/${id}`, {
    plateNumber,
    type,
    captchaToken,
  });

  return response;
};

export const deleteSubscription = async (id) => {
  const response = await axios.delete("vehicles", { data: { id } });
  return response;
};

export const getActiveSubscriptions = async () => {
  const response = await axios.get("subscriptions/actives");

  return response;
};

export const getSubscriptionsByPlateNumber = async ({ plateNumber }) => {
  const response = await axios.get(
    "subscriptions/plates?plateNumber=" + plateNumber
  );
  return response;
};

export const getPassiveSubscriptions = async () => {
  const response = await axios.get("subscriptions/passives");

  return response;
};

export const getSubscriptionById = async (id) => {
  const response = await axios.get(`subscriptions/${id}`);

  return response.data;
};

export const getTicketStats = async (eventId, month = null, viewMode = 'week') => {
  const params = new URLSearchParams();
  if (month) params.append('month', month);
  if (viewMode) params.append('viewMode', viewMode);
  
  const response = await axios.get(`/subscriptions/admin/${eventId}/stats?${params.toString()}`);
  return response;
};
